import React, { Component } from "react";
import { Link } from "react-router-dom";
import $ from "jquery";

import "../styles/components/SectionRoad.css";

import track from "../assets/icons-main/tor3.svg";
import track2 from "../assets/icons-main/tor4.svg";

export class SectionRoad extends Component {
  componentDidMount() {
    $(document).ready(() => {
      setTimeout(() => {
        this.animateElement();
      }, 1500);
    });
  }

  animateElement() {
    const elementJQ = $(".path-two");
    const element = document.querySelector(".path-two");
    if (elementJQ && element) {
      elementJQ.animate({ strokeDashoffset: element.getTotalLength() }, 6000, "linear", () => {
        elementJQ.css({ strokeDashoffset: 0 });
        this.animateElement();
      });
    }
  }

  render() {
    return (
      <div className="section section-road">
        <div className="svg-wrapper">
          <img className="svg" style={{display: 'none'}} src={track} alt="" />
          <img className="svg" style={{display: 'none'}} src={track2} alt="" />
        </div>
        <div className="container container-small">
          <div className="row">
            <div className="col-12">
              <h2 dangerouslySetInnerHTML={{ __html: this.props.data.titleRoad }} />
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-md-6 col-md-pull-2">
              <Link className="btn-general btn-general--secondary" to={this.props.data.button.url}>
                {this.props.data.button.title}
              </Link>
            </div>
            <div className="col-12 col-md-4 col-md-pull-1">
              <p>{this.props.data.descRoad}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SectionRoad;
